module.exports = __webpack_public_path__ + "static/road trip radio-717eade0bfd11bc5cb570fbac9d044f8.mp3";